import React from "react";

function CustomToolbar(props) {
  const { label, onNavigate, onView } = props;

  return (
    <div className="rbc-toolbar">
      {/* Left side: navigation */}
      <span className="rbc-btn-group">
        <button type="button" onClick={() => onNavigate("PREV")}>
          Back
        </button>
        <button type="button" onClick={() => onNavigate("NEXT")}>
          Next
        </button>
      </span>

      {/* Center: current label */}
      <span className="rbc-toolbar-label">{label}</span>

      {/* Right side: view switcher */}
      <span className="rbc-btn-group">
        <button type="button" onClick={() => onView("month")}>
          Month
        </button>
        <button type="button" onClick={() => onView("week")}>
          Week
        </button>
        <button type="button" onClick={() => onView("day")}>
          Day
        </button>
        <button type="button" onClick={() => onView("agenda")}>
          Agenda
        </button>
      </span>
    </div>
  );
}

export default CustomToolbar;
